(function ($, XTT) {
	'use strict';

	XTT.tooltip = {
		_autoload: [
			'handleTooltipEvents'
		],

		handleTooltipEvents: function () {
			$('.xtt-tooltip-trigger').hover(XTT.tooltip.handleTooltipVisibilty);
		},

		handleTooltipVisibilty: function() {
			var $this = $(this);
			$this.next('.xtt-tooltip-body').toggleClass('open');
		}

	};

})
(jQuery, XTT);